const API_URL = process.env.REACT_APP_API_URL + "package/";
const token = localStorage.getItem("token");



export const GetAllPackagesApi = async ({ 
  page = 1, 
  limit = 10,
  filters = {}
}) => {
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });

    const response = await fetch(`${API_URL}?${params.toString()}`);
    
    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();
    
    return {
      status: 'success',
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    console.error("[GetAllReservationsApi] Error:", error);
    throw error;
  }
};
  



export const FetchCreatePackeges = async (formData) => {
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
      },
      body: formData
    });

    let data = null;

    if (response.status === 201) {
      data = await response.json();
      console.log("[FetchCreatePackeges] Successful response:", data);
    }

    return {
      data,
      status: response.status
    };
  } catch (error) {
    console.error("[FetchCreatePackeges] Error creating package:", error);
    return {
      data: null,
      status: 500
    };
  }
};

export const deletePackeges = async (id) => {
  try {
    const response = await fetch(API_URL + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    return {
      status: response.status
    };
  } catch (error) {
    console.error("[deletePackeges] Error deleting package:", error);
    return {
      status: 500
    };
  }
};

export const GetAllPackegesByIdApi = async (id) => {
  let data = null;
  let response = await fetch(API_URL + id, {
    method: 'GET',
  });

  if (response.status === 200) {
    data = await response.json();
  }

  return {
    data: data,
    status: response.status
  };
};

export const UpdatePackegesApi = async (formData, id) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${API_URL}${id}`, { 
      method: "PUT",
      headers: {
        "Authorization": `Bearer ${token}`,
      
      },
      body: formData
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `Update failed with status ${response.status}`);
    }

    return {
      data: data,
      status: response.status
    };
  } catch (error) {
    console.error("API Error:", error);
    throw error; 
  }
};